import React from 'react';

import { TabSelector, TabSelectorProps } from 'components/shared/TabSelector';
import { EOrganizedBy, IApiFlightTripEvent } from 'detailsv2/structure';

import { FlightAPIOptions } from '../FlightAPIOption/types';
import { FlightTab } from '../types';
import s from './FlightTabs.module.css';
import { FlightApiContent, FlightNumberTab, FlightRouteTab, FlightManualContent, FlightManualTab } from './Tabs';

type Props = {
  tripEvent: IApiFlightTripEvent;
  activeItems: FlightAPIOptions;
  setActiveItems: React.Dispatch<React.SetStateAction<FlightAPIOptions>>;
  activeTab: FlightTab;
  setActiveTab: (tab: FlightTab) => void;
  isDisabled: boolean;
  organizedBy: EOrganizedBy;
};

export const FlightTabs = (props: Props) => {
  const { activeTab, setActiveTab, ...rest } = props;
  const isEdit = !!props.tripEvent.id;
  const isFlightAPI = props.tripEvent.data.fromFsService;

  const tabs: TabSelectorProps['tabs'] = [
    {
      labelContent: <FlightNumberTab />,
      content: <FlightApiContent activeTab={activeTab} setActiveTab={setActiveTab} {...rest} />,
    },
    {
      labelContent: <FlightRouteTab />,
      content: <FlightApiContent activeTab={activeTab} setActiveTab={setActiveTab} {...rest} />,
    },
    { labelContent: <FlightManualTab />, content: <FlightManualContent activeTab={activeTab} {...rest} /> },
  ];

  const disabledTabs = (() => {
    if (isEdit && isFlightAPI) return [2];
    if (isEdit && !isFlightAPI) return [0, 1];

    return [];
  })();

  return (
    <div className={s.container}>
      <TabSelector
        initialActiveTab={activeTab}
        disabledTabs={disabledTabs}
        onTabChange={setActiveTab}
        tabsClassName={s.tabsContainer}
        tabs={tabs}
      />
    </div>
  );
};
